import { Component, OnInit, ViewChild, ViewChildren, QueryList, TemplateRef } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { DataSourceService } from 'src/app/services/dataSource.service';
import * as moment from 'moment';
import { ThemePalette } from '@angular/material/core';
import { UserManager } from 'src/app/models/usermanagement/userManager';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import Swal from 'sweetalert2';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccesscontrolPolicyService } from 'src/app/services/accesscontrol-policy.service';
import { AccessControlPolicy } from 'src/app/models/usermanagement/accessControl';
import { CustomValidators } from 'src/app/components/custom-validators';
@Component({
  selector: 'app-usermanager',
  templateUrl: './usermanager.component.html',
  styleUrls: ['./usermanager.component.scss']
})
export class UsermanagerComponent implements OnInit {
  @ViewChild('resetModalContent') private resetModel!: TemplateRef<any>;
  managerId: any;
  groupList!: any[];
  formMode!: boolean;
  isaddNewUserModeItemModelVisible = false;
  UserId!: number;
  formLoader!: boolean;
  userModelRowId!: number;
  displayUserModal = false;
  groupId!: any;
  isUserGroupModelVisible = false;
  usergroup!: any;
  isaddNewGroupItemModelVisible!: boolean;
  GroupId!: number;
  breadcrumList: any;
  IsAccess: any;
  IsWrite: any;
  policyData!: AccessControlPolicy;
  minimumLength!: any;
  resetForm!: FormGroup;
  resetPasUserId!: number;
  constructor(
    private formBuilder: FormBuilder,
    // tslint:disable-next-line:no-shadowed-variable
    private DataSourceService: DataSourceService,
    private toaster: ToastrService,
    private dialog: MatDialog,
    private kpiMaster: KpimasterService,
    public router: Router,
    private spinner: NgxSpinnerService,
    private roleService: UserManagementService,
    private policyService: AccesscontrolPolicyService
  ) { }
  public color: ThemePalette = 'primary'
  public formGroup = new FormGroup({
    // group: new FormControl('', [Validators.required]),
    UserName: new FormControl('', [Validators.required]),
    Password: new FormControl('', [Validators.required]),
    Mobile: new FormControl('', [Validators.maxLength(15), Validators.minLength(10)]),
    Email: new FormControl('', [Validators.email]),
    Name: new FormControl('', [Validators.required]),
    IsAdmin: new FormControl(''),
  });
  public userForm = new FormGroup({
    group: new FormControl('', [Validators.required]),
  });
  usermanagerdata!: UserManager[];
  // tslint:disable-next-line:max-line-length
  userColumns: string[] = ['userManagerActions', 'userName', 'name', 'email', 'mobile', 'isGroupAdmin', 'createdBy', 'createdon', 'isLocked'];
  userData!: MatTableDataSource<UserManager>;


  @ViewChild(MatTable) table!: MatTable<UserManager>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: any;
  // @ViewChild('displayUserModal') private displayUserModal!: TemplateRef<any>;

  ngOnInit(): void {
    this.formMode = true;
    this.resetForm = this.formBuilder.group({
      Password: ['', Validators.required]
    });
    this.getGroupsData();

    this.GetBreadcrumList();
    //this.GetMenuAccess();
  }


  //breadCrumb

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.kpiMaster.GetMenuAccess(key).subscribe((data: any) => {
      // this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;

    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  GetBreadcrumList(): any {
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.roleService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      console.log(data.BreadcrumList);
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
    // return false;
  }

  openResetModal(userId: number): void {
    this.resetPasUserId = userId;
    this.resetPasswordForm();
    if (this.policyData) {
      this.minimumLength = this.policyData.minimumLength;
      this.resetForm.get('Password').addValidators([
        Validators.minLength(this.policyData.minimumLength)
      ])
      if (this.policyData.isAlphanumeric) {
        this.resetForm.get('Password').addValidators(Validators.compose([
          Validators.required,
          CustomValidators.patternValidator(/\d/, {
            hasNumber: true
          }),
          // check whether the entered password has upper case letter
          CustomValidators.patternValidator(/[A-Z]/, {
            hasCapitalCase: true
          }),
          // check whether the entered password has a lower case letter
          CustomValidators.patternValidator(/[a-z]/, {
            hasSmallCase: true
          }),
        ]))
      }
      if (this.policyData.isSymbols) {
        this.resetForm.get('Password').addValidators(Validators.compose([
          Validators.required,
          // check whether the entered password has a special character
          CustomValidators.patternValidator(
            /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
            {
              hasSpecialCharacters: true
            }
          )
        ]))
      }
    }
    this.dialog.open(this.resetModel, { height: 'auto', width: '40%' });
  }

  changePassword() {
    this.spinner.show();
    const data = {
      UsersId: this.resetPasUserId,
      Password: this.resetForm.value.Password,
      GroupId: parseInt(this.userForm.value.group, 10),
      ResetByAdmin: JSON.parse(localStorage.logged_in_user)?.IsAdmin
    };
    this.roleService.changeUserPassword(data).subscribe(res => {
      this.spinner.hide();
      if (res.isError) {
        this.toaster.warning(res.message);
      } else {
        this.toaster.success(res.message);
        this.closeResetModal();
      }
    },
      (error) => {
        this.toaster.error('Error', error.message);
      });
  }

  closeResetModal(): void {
    this.dialog.closeAll();
  }

  resetPasswordForm() {
    this.resetForm.get('Password').setValue('');
  }

  getGroupsData(): void {
    // this.spinner.show();
    const key = {
      Id: 0,
    };
    this.roleService.getGroupData(key).subscribe((data: any) => {
      this.groupList = data.masterList;
      this.GroupId = this.groupList[0].TypeId;
      this.userForm.get('group')?.setValue(this.groupList[0].TypeId);
      this.getPolicy();
      this.getMasterUsers();
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
        //  this.spinner.hide();
      }
    );
  }
  unlockUser(element: any) {
    this.roleService.unlockUser(element.UserId).subscribe(res => {
      this.toaster.success(res.message);
      this.getMasterUsers();
    },
      (error) => {
        this.toaster.error(error.message);
      }
    );
  }
  getMasterUsers(): void {
    const key = {
      GroupId: this.GroupId,
      UserId: JSON.parse(localStorage.user).UserId
    };
    this.spinner.show();
    this.roleService.getUsersData(key).subscribe(
      (users: any) => {
        this.userData = new MatTableDataSource<any>(users.UserList);
        this.spinner.hide();

        this.getPaginator();
      },
      (error) => {
        this.spinner.hide();

        this.toaster.error(error.error.message);
      }
    );
  }
  getPolicy() {
    this.policyService.getPolicyByGroup(parseInt(this.userForm.value.group, 10)).subscribe(policy => {
      this.policyData = policy[0];
      if (this.policyData) {
        this.minimumLength = this.policyData.minimumLength;
        this.formGroup.get('Password').addValidators([
          Validators.minLength(this.policyData.minimumLength)
        ])
        if (this.policyData.isAlphanumeric) {
          this.formGroup.get('Password').addValidators(Validators.compose([
            Validators.required,
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
          ]))
        }
        if (this.policyData.isSymbols) {
          this.formGroup.get('Password').addValidators(Validators.compose([
            Validators.required,
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            )
          ]))
        }
      }
    });
  }
  onGroupChange(event: any): void {
    this.getPolicy();
    this.getMasterUsers();
  }

  openModal(): void {
    this.formMode = true;
    this.formGroup.reset();
    // this.dialog.open(this.displayUserModal, {height: '90%', width: '50%'});
    this.displayUserModal = true;
  }
  openModaledit(): void {
    this.formMode = false;
    this.formGroup.get('Password').clearValidators();
    this.formGroup.get('Password').updateValueAndValidity();
    // this.dialog.open(this.displayUserModal, {height: '90%', width: '50%'});
    this.displayUserModal = true;
    // this.getMasterUsers();
  }
  getPaginator(): void {
    setTimeout(() => {
      this.userData.paginator = this.paginator;
      this.userData.sort = this.sort;
    }, 1000);
  }

  closeaddNewPlantItemModel(): void {
    this.displayUserModal = false;
  }

  addNewPlantModeItemlFormSubmit(): void {
    const groupKey = {
      UserName: this.formGroup.value.UserName,
      Password: this.formGroup.value.Password,
      Name: this.formGroup.value.Name,
      Mobile: this.formGroup.value.Mobile,
      Email: this.formGroup.value.Email,
      IsAdmin: this.formGroup.value.IsAdmin,
      UserId: JSON.parse(localStorage.user).UserId,
      GroupId: this.userForm.value.group,
      TransactionTypeId: 1
    };
    this.roleService.submitUsersData(groupKey).subscribe(
      (response: any) => {
        // this.toaster.success('Success', 'Frequency Added Successfully');
        this.showPopupMsg(response.ErrorMessage);
        this.getMasterUsers();
        this.displayUserModal = false;
        // this.formGroup.reset();
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
    this.table.renderRows();
    this.formGroup.reset();
    this.isaddNewUserModeItemModelVisible = false;
  }

  openEditPlantItemModel(element: any): void {
    this.openModaledit();
    this.userModelRowId = element.UserId;
    this.formGroup.get('UserName')?.setValue(element.UserName);
    this.formGroup.get('Name')?.setValue(element.Name);
    this.formGroup.get('IsAdmin')?.setValue(element.IsAdmin);
    this.formGroup.get('Mobile')?.setValue(element.Mobile);
    this.formGroup.get('Email')?.setValue(element.Email);
  }
  openaddNewPlantItemModel(): void {
    this.displayUserModal = true;
    this.formMode = true;
  }

  openPlantGroupModel(element: any): void {
    this.isUserGroupModelVisible = true;
    this.getMasterUsers();
    this.usergroup = element;
    // this.plantGroupSource.data = plantGroupData;
    // this.treeControl.dataNodes = this.plantGroupSource.data;
  }
  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.userData.filter = filterValue.trim().toLowerCase();

    if (this.userData.paginator) {
      this.userData.paginator.firstPage();
    }
  }

  editPlantModeItemlFormSubmit(): void {
    const groupKey = {
      // this.formMode = false;
      UserName: this.formGroup.value.UserName,
      // Password: this.formGroup.value.Password,
      Name: this.formGroup.value.Name,
      Mobile: this.formGroup.value.Mobile,
      Email: this.formGroup.value.Email,
      IsAdmin: this.formGroup.value.IsAdmin,
      UserId: this.userModelRowId,
      GroupId: this.userForm.value.group,
      TransactionTypeId: 2
    };
    console.log(groupKey);
    this.roleService.submitUsersData(groupKey).subscribe(
      (response: any) => {
        // this.toaster.success('Success', 'Group Update Successfully');
        if (response.HasError) {
          this.toaster.error(response.ErrorMessage);
        } else {
          this.toaster.success(response.ErrorMessage);
        }
        this.getMasterUsers();
        this.formGroup.reset();
        this.displayUserModal = false;
      },
      (error) => {
        this.toaster.error(error.ErrorMessage);
      }
    );
    this.table.renderRows();
    // this.formGroup.reset();
    this.isaddNewUserModeItemModelVisible = false;
    this.table.renderRows();
  }

  deleteGroupNode(node: any): void {
    // if (this.plnatPermission.IsDelete) {
    Swal.fire({
      title: 'Are you sure ?',
      text: 'You want to delete it',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const data = {
          UserName: '',
          Password: '',
          IsAdmin: '',
          IsOptional: true,
          IsActive: true,
          Mobile: '',
          Email: '',
          TransactionTypeId: 3,
          UserId: node.UserId,
          GroupId: this.userForm.value.group
        };
        console.log(data);
        this.roleService.submitUsersData(data).subscribe(response => {
          if (response) {
            // this.showPopupMsg(response[data].ErrorMessage);
            // this.toaster.success('Success', response.ErrorMessage);
            this.isaddNewGroupItemModelVisible = false;
            this.isUserGroupModelVisible = true;
            this.getMasterUsers();
          } else {
            // this.showPopupMsg(response.ErrorMessage);
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your ' + node.text + ' is safe :)', 'error');
      }
    });
    // } else {
    //   this.toaster.error('Alert!', 'you do not have permission to access');
    // }
  }

  showPopupMsg(msg: any): any {
    if (msg.substring(2, 1) === '0') {
      this.toaster.success('Success', msg.substring(3, msg.length));
      this.isaddNewUserModeItemModelVisible = false;
    }
    else {
      this.toaster.error('Error', msg.substring(3, msg.length));
    }
  }

}
